import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./RepairService.module.scss";

const RepairService: React.FC = () => {
  const { t } = useTranslation("common");
  const steps = t("repairService.steps", { returnObjects: true }) as Array<{
    number: string;
    title: string;
    description: string;
  }>;

  return (
    <div className="container section">
      <div
        className={`${styles.repairService} sectionContainer sectionContainerWhite bigSection`}
      >
        <div className={`sideP64 titleCont ${styles.mainReviewBlock}`}>
          <div className="titleBlock">
            <h2>{t("repairService.title")}</h2>
          </div>
        </div>
        <div className={`${styles.repairServiceContainer} sideP64`}>
          <div className={styles.stepsContainer}>
            {steps.map((step, index) => (
              <div key={step.number} className={styles.step}>
                <div className={styles.stepNumber}>{step.number}</div>
                <div className={styles.pointBlock}>
                  <div className={styles.point}></div>
                </div>
                {index < steps.length - 1 && (
                  <div className={styles.stepline}></div>
                )}
                <div className={styles.stepContent}>
                  <h2 className={styles.stepTitle}>{step.title}</h2>
                  <p className={styles.stepText}>{step.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className={styles.imgWrapper}>
            <img
              src="/images/werkstatt-berlin-delivery.webp"
              alt={t("repairService.imageAlt")}
              className={styles.headerImage}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RepairService;
